import get from 'lodash/get';
import ParamTypeHelper from '../../../BlockEditorParams/ParamTypes/param-type-helper';
import ConditionEditor from './ConditionEditor';
import AdvanceValueConditionEditor from './AdvanceValueConditionEditor';
import JoinConditionEditor from './JoinConditionEditor';
import ParamsService from '@/utils/ParamsService';
const { PLY_PARAMS } = ParamsService;

function tableOneItems(node, param, previousStepsData, insertDataReplaceDict, configurationsMappingBlocksUUIDs) {
	if (param.depends_on?.length > 0) {
		const dependsOnParamKey = param.depends_on[0];
		return getTableItems(node, dependsOnParamKey, previousStepsData, insertDataReplaceDict, configurationsMappingBlocksUUIDs);
	}
	return {};
}

function tableTwoItems(node, param, previousStepsData, insertDataReplaceDict, configurationsMappingBlocksUUIDs) {
	if (param.depends_on?.length === 2) {
		const dependsOnParamKey = param.depends_on[1];
		return getTableItems(node, dependsOnParamKey, previousStepsData, insertDataReplaceDict, configurationsMappingBlocksUUIDs);
	}
	return {};
}

function sourceOfList(node, dependsOnParamKey) {
	if (node.params_map[dependsOnParamKey]) {
		return node.params_map[dependsOnParamKey][PLY_PARAMS.listSourceParam.key];
	}
	return null;
}

function getTableItems(node, dependsOnParamKey, previousStepsData, insertDataReplaceDict = {}, configurationsMappingBlocksUUIDs = []) {
	const dependsOnValue = sourceOfList(node, dependsOnParamKey);
	if (dependsOnValue) {
		const dependsOnNodeUUID = ParamsService.extractNodeUUIDFromValue(dependsOnValue);
		const dependsOnPath = ParamsService.extractPathFromValue(dependsOnValue, insertDataReplaceDict, configurationsMappingBlocksUUIDs);
		const dependsOnNodePreviousData = previousStepsData[dependsOnNodeUUID];

		const tableItems = get(dependsOnNodePreviousData, dependsOnPath, []);
		return { tableItems, sourceOfList: dependsOnValue };
	}

	return {};
}

function getComponentConfig(previousStepsData, insertDataReplaceDict, configurationsMappingBlocksUUIDs) {
	const { tableItems: tableOne, sourceOfList: tableOneSourceOfList } = tableOneItems(
		this.node,
		this.param,
		previousStepsData,
		insertDataReplaceDict,
		configurationsMappingBlocksUUIDs
	);
	const { tableItems: tableTwo, sourceOfList: tableTwoSourceOfList } = tableTwoItems(
		this.node,
		this.param,
		previousStepsData,
		insertDataReplaceDict,
		configurationsMappingBlocksUUIDs
	);
	const isConditionDependsOnTable = this.param?.depends_on?.length > 0;

	const COMMON_PROPS = {
		...this.$attrs,
		canRemove: !this.readonly,
		param: this.param,
		node: this.node,
		items: tableOne,
		readonly: this.readonly,
		sourceOfList: tableOneSourceOfList,
		isConditionDependsOnTable,
	};
	const ADVANCED_VALUE_PROPS = {
		...COMMON_PROPS,
		itemsTwo: tableTwo,
		itemsTwoSourceOfList: tableTwoSourceOfList,
	};
	const JOIN_PROPS = {
		...COMMON_PROPS,
		itemsTwo: tableTwo,
		itemsTwoSourceOfList: tableTwoSourceOfList,
	};
	const COMMON_LISTENERS = {};
	const BASE_CONDITION = ParamTypeHelper.buildComponentConfigItem(ConditionEditor, COMMON_PROPS, COMMON_LISTENERS);
	const ADVANCE_CONDITION = ParamTypeHelper.buildComponentConfigItem(AdvanceValueConditionEditor, ADVANCED_VALUE_PROPS, COMMON_LISTENERS);
	const JOIN_CONDITION = ParamTypeHelper.buildComponentConfigItem(JoinConditionEditor, JOIN_PROPS, COMMON_LISTENERS);

	if (this.param.is_join) {
		return JOIN_CONDITION;
	}
	return this.param?.advance_condition_value ? ADVANCE_CONDITION : BASE_CONDITION;
}

const ConditionEditorService = {
	getComponentConfig,
};

export default ConditionEditorService;
